import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import Button from "../../../Button/Button";
import styles from "../CheckboxModel/CheckboxModel.module.scss";
import { Radio } from "antd";
import CustomSelect from "../../CustomSelect/CustomSelect";
import { fetchProductListing } from "../../../../redux/unitSlice/unitSlice";
import { useDispatch, useSelector } from "react-redux";

const VendorModel = ({
    isOpen,
    onClose,
    title = "Modal",
    initialValues = {},
    onSubmit,
    labelHeading,
    placeholder,
    supplyOptions = [],
    packageOptions = [],
    options = [],
}) => {
        const dispatch = useDispatch();
        const [selectedPackages, setSelectedPackages] = useState(initialValues.packageTypes || []);
        const [showOptions, setShowOptions] = useState(false);
        const [searchTerm, setSearchTerm] = useState('');
        const [supply, setSupply] = useState(
                supplyOptions.length > 0 ? supplyOptions[0].value : '',
        );

        const [filteredPackageOptions, setFilteredPackageOptions] = useState([]);
        const [selectedOption, setSelectedOption] = useState(initialValues.unitCommercial || []); // Default selected

        useEffect(() => {
                setSelectedPackages(initialValues.packageTypes || []);
        }, [initialValues.packageTypes, isOpen]);

        useEffect(() => {
                setFilteredPackageOptions(packageOptions);
                setSelectedOption(''); // Set default selected when modal opens
        }, [packageOptions]);

        const prevSupplyOptionsRef = useRef([]);

        useEffect(() => {
                const supplyOptionsChanged =
                        JSON.stringify(prevSupplyOptionsRef.current) !==
                        JSON.stringify(supplyOptions);

                if (supplyOptionsChanged && supplyOptions.length > 0) {
                        const initialSupply = supplyOptions[0].value;
                        setSupply(initialSupply);
                        dispatch(fetchProductListing({ productTypeCode: initialSupply }));
                        prevSupplyOptionsRef.current = supplyOptions;
                }
        }, [supplyOptions]);

        const handleCheckboxChange = (e, packageData) => {
                setSelectedPackages(
                        (prev) =>
                                e.target.checked
                                        ? [...prev, packageData] // Add entire package object
                                        : prev.filter((p) => p.code !== packageData.code), // Remove by code
                );
        };

        const handleSubmit = () => {
                if (!selectedOption || selectedPackages.length === 0 || !selectedOption || !supply)
                        return;
                onSubmit({
                        packageTypes: selectedPackages,
                        unitCommercial: selectedOption, // Add this line
                        productTypeCode: supply,
                });
                setShowOptions(false);
                onClose();
                setSupply('');
                sessionStorage.removeItem('supply');
        };

        const filteredPackages = filteredPackageOptions.filter(
                (pkg) =>
                        pkg.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                        pkg.type.toLowerCase().includes(searchTerm.toLowerCase()),
        );


        return (
                <div className="fixed inset-0 flex items-center justify-end bg-gray-800 bg-opacity-50 z-20">
                        <div className="bg-white rounded-2xl shadow-lg w-[650px] flex flex-col max-h-[90vh]">
                                {/* Header */}
                                <div className="flex justify-between items-center border-b px-6 py-4 rounded-t-2xl">
                                        <h2 className="text-[18px] font-semibold">{title}</h2>
                                        <button
                                                onClick={onClose}
                                                aria-label="Close Modal"
                                        >
                                                ✖
                                        </button>
                                </div>

                                {/* Supply Selection */}
                                {supplyOptions.length > 0 && (
                                        <div className="flex flex-col px-6 pt-4">
                                                <label className="text-[#656669] font-medium text-sm">
                                                        Product Type{' '}
                                                        <span className="text-red-500">*</span>
                                                </label>
                                                <Radio.Group
                                                        value={supply}
                                                        onChange={(e) => {
                                                                const selectedSupply =
                                                                        e.target.value;
                                                                setSupply(selectedSupply);
                                                                dispatch(
                                                                        fetchProductListing({
                                                                                productTypeCode:
                                                                                        selectedSupply,
                                                                        }),
                                                                );
                                                        }}
                                                        className="pt-2 flex space-x-16"
                                                >
                                                        {supplyOptions.map((option) => (
                                                                <Radio
                                                                        key={option.value}
                                                                        value={option.value}
                                                                        className="text-[#1F2125] font-normal"
                                                                >
                                                                        {option.label}
                                                                </Radio>
                                                        ))}
                                                </Radio.Group>
                                        </div>
                                )}

                                <div className="px-6 pt-4 pb-2">
                                        <p className="text-sm text-[#656669] font-medium">
                                                {' '}
                                                Unit Commercial{' '}
                                                <span className="text-red-500">*</span>
                                        </p>
                                        <CustomSelect
                                                options={options}
                                                placeholder={'Select'}
                                                onChange={(value) => setSelectedOption(value)}
                                                value={selectedOption}
                                                defaultValue={options.find(
                                                        (option) => option.value === 'BAP,Ranipet',
                                                )}
                                                required
                                                className="w-full pb-2"
                                        />
                                </div>

                                {/* Package Selection */}
                                <div className="flex flex-col px-6 py-4">
                                        <label className="text-sm text-[#656669] font-medium pb-2">
                                                {labelHeading}{' '}
                                                <span className="text-red-500">*</span>
                                        </label>

                                        {!showOptions && (
                                                <div
                                                        className="w-full border border-[#D3D3D4] rounded-md py-2 px-3 text-sm cursor-pointer bg-white flex justify-between"
                                                        onClick={() => {
                                                                setShowOptions(true);
                                                        }}
                                                >
                                                        {selectedPackages.length
                                                                ? `${selectedPackages.length} Packages selected`
                                                                : placeholder}
                                                        <DownOutlined />
                                                </div>
                                        )}

                                        {showOptions && (
                                                <div className="border border-[#D3D3D4] rounded-md bg-white mt-2">
                                                        <div className="relative p-3">
                                                                <input
                                                                        type="text"
                                                                        placeholder="Search"
                                                                        value={searchTerm}
                                                                        onChange={(e) =>
                                                                                setSearchTerm(
                                                                                        e.target
                                                                                                .value,
                                                                                )
                                                                        }
                                                                        className="w-full border border-[#D3D3D4] bg-[#FBFBFB] rounded-lg py-2 pl-10 text-sm"
                                                                />
                                                                <SearchOutlined className="absolute left-6 top-1/2 transform -translate-y-1/2 text-[#656669]" />
                                                        </div>

                                                        <div className="flex font-semibold text-[#585B61] text-sm px-3 py-2">
                                                                <div className="w-8"></div>
                                                                <div className="w-16">CODE</div>
                                                                <div className="flex-1">
                                                                        DESCRIPTION
                                                                </div>
                                                                <div className="w-32">
                                                                        PRODUCT CODE
                                                                </div>
                                                                <div className="w-32">TYPE</div>
                                                        </div>

                                                        <div className="max-h-[200px] overflow-y-auto">
                                                                {filteredPackages.length > 0 ? (
                                                                        filteredPackages.map(
                                                                                (pkg) => (
                                                                                        <div
                                                                                                key={
                                                                                                        pkg.code
                                                                                                }
                                                                                                className="flex items-center text-sm px-3 py-2"
                                                                                        >
                                                                                                <div className="w-8">
                                                                                                        <input
                                                                                                                type="checkbox"
                                                                                                                checked={selectedPackages.some(
                                                                                                                        (
                                                                                                                                p,
                                                                                                                        ) =>
                                                                                                                                p.typeCode ===
                                                                                                                                pkg.typeCode,
                                                                                                                )}
                                                                                                                onChange={(
                                                                                                                        e,
                                                                                                                ) =>
                                                                                                                        handleCheckboxChange(
                                                                                                                                e,
                                                                                                                                pkg,
                                                                                                                        )
                                                                                                                }
                                                                                                                className={
                                                                                                                        styles.customCheckbox
                                                                                                                }
                                                                                                        />
                                                                                                </div>
                                                                                                <div className="w-16">
                                                                                                        {
                                                                                                                pkg.code
                                                                                                        }
                                                                                                </div>
                                                                                                <div className="flex-1">
                                                                                                        {
                                                                                                                pkg.description
                                                                                                        }
                                                                                                </div>
                                                                                                <div className="w-32">
                                                                                                        {
                                                                                                                pkg.typeCode
                                                                                                        }
                                                                                                </div>
                                                                                                <div className="w-32">
                                                                                                        {
                                                                                                                pkg.type
                                                                                                        }
                                                                                                </div>
                                                                                        </div>
                                                                                ),
                                                                        )
                                                                ) : (
                                                                        <div className="text-sm text-gray-500 px-3 py-2">
                                                                                No packages
                                                                                available
                                                                        </div>
                                                                )}
                                                        </div>
                                                </div>
                                        )}

                                        {/* Summary Text*/}
                                        <div className="mt-3 text-sm text-[#94969C] font-semibold">
                                                {selectedPackages.length > 0 && supply
                                                        ? `${
                                                                  selectedPackages.length
                                                          } Products selected (${selectedPackages
                                                                  .map((p) => p.description)
                                                                  .join(', ')}).`
                                                        : ''}
                                        </div>
                                </div>

                                {/* Footer */}
                                <div className="border-t bg-[#F5F6F5] px-6 py-4 flex justify-end space-x-2 rounded-b-2xl">
                                        <Button
                                                text="Cancel"
                                                variant="secondary"
                                                onClick={onClose}
                                        />
                                        <Button
                                                text="Submit"
                                                onClick={handleSubmit}
                                                variant={'primary'}
                                                disabled={
                                                        selectedPackages.length === 0 ||
                                                        !selectedOption ||
                                                        !supply
                                                }
                                        />
                                </div>
                        </div>
                </div>
        );
};

export default VendorModel;
